import { createBrowserHistory } from 'history';
import isBrowser from 'is-in-browser';

const history = isBrowser ? createBrowserHistory() : {};

export default history;